import { rgba } from 'polished';

const tintsLevels = [15, 30, 45, 60, 75, 90];
function tintsFrom(colors, levels, isGradient) {
  const tints = {};

  if (isGradient) {
    Object.keys(colors).forEach((name) => {
      const [a, c1, c1a, c2, c2a] = colors[name];
      tints[name] = `linear-gradient(${a}, ${c1} ${c1a}, ${c2} ${c2a})`;

      for (let i = 0; i < levels; i++) {
        const tint = tintsLevels[i];
        tints[`${name}_${tint}`] = `linear-gradient(${a}, ${rgba(c1, tint / 100)} ${c1a}, ${rgba(
          c2,
          tint / 100
        )} ${c2a})`;
      }
    });

    return tints;
  }

  Object.keys(colors).forEach((name) => {
    tints[name] = colors[name];

    for (let i = 0; i < levels; i++) {
      const tint = tintsLevels[i];
      tints[`${name}_${tint}`] = rgba(colors[name], tint / 100);
    }
  });

  return tints;
}

const primaryMain = {
  irisBlue: '#624DE3',
  darkBlue: '#00234B',
  blank: '#FFFFFF',
};

const secondaryMain = {
  turquoise: '#75E8F0',
  darkTurquoise: '#01B0BB',
  royalPurple: '#4E3DB5',
  chambray: '#3639A4',

  redPink: '#FF4A5A',
  salmon: '#FF9066',
  candlelight: '#FFD012',
  mustard: '#FFE15A',

  radiance: '#0090FF',
  cerulean: '#00B4F5',
  cerise: '#E83E8C',
  cabaret: '#D03765',

  deYork: '#6FCF97',
  conifer: '#B2E33C',
};

const neutralMain = {
  bayoux: '#525F7F',
  lynch: '#617798',
  pigeon: '#A8BDD4',
  heather: '#B1BECD',

  geyser: '#CBD3DC',
  mischka: '#E8ECEE',
  catskillWhite: '#EAF0F6',
  athensGray: '#ECEDF2',
  linkWater: '#F4F7FC',
  alabaster: '#F8FBFF',
};

const shadesMain = {
  governor: '#3D41B6',
  spindle: '#B7B8EB',
  moonRaker: '#D0CAF7',
  selago: '#EFEDFC',
};

const lightsMain = {
  iceberg: '#DFF5F6',
  cosmos: '#FFDBDE',
  forget: '#FFF1EC',
  ginFizz: '#FFF9E1',

  pattensBlue: '#DFF1FF',
  wispPink: '#FCE7F0',
  feta: '#F5FBE6',
  foam: '#DFF5FD',
};

const gradientsMain = {
  purpleMinsk: ['227deg', '#5240CB', '0%', '#3C2E92', '80%'],
  zircon: ['180deg', '#F9FBFF', '0%', '#F0F5FF', '100%'],
};

const allColors = {
  ...tintsFrom(primaryMain, 6),
  ...tintsFrom(secondaryMain, 5),
  ...tintsFrom(neutralMain, 5),
  ...tintsFrom(shadesMain, 5),
  ...tintsFrom(lightsMain, 5),
  ...tintsFrom(lightsMain, 5),
  ...tintsFrom(gradientsMain, 5, true),
};

export default allColors;
